import { graphql } from "react-relay";
import { SuggestionsFeed } from "./SuggestionsFeed";

export const query = graphql`
  query SuggestionsFeedRendererQuery($debugFetchDate: BigInt) {
    viewer {
      ...SuggestionsFeed_viewer @arguments(debugFetchDate: $debugFetchDate)
    }
  }
`;
